import { Container } from '@/platform/ui';
import PagePlaceholder from './components/PagePlaceholder';
import PhoneCallPanel from './components/PhoneCallPanel';

const PhoneCallView = () => (
    <Container fluid>
        <PagePlaceholder />

        <PhoneCallPanel />
    </Container>
);

export default PhoneCallView;
